let Http = require('./http');

module.exports = {
	mixins: [Http],

	props: {
		listType: {
			type: String
		},
		listItems: {
			type: Array,
			default() {
				return []
			}
		},
		endpoint: {
			type: String,
			default: ''
		}, 
		noItems: {
			type: String,
			default: 'No items found.'
		},
		paginate: {
			type: Boolean,
			default: false
		},
		query: {
			type: String,
			default: ''
		},
		cols: {
			type: [String, Number],
			default: 3
		},
		removable: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			items : [],
			loading: true,
			loadingMore: false,
			noItemsMessage: this.noItems,
			pagination: false,
			maxColumns: 12
		}
	},

	created() {
		this.getItems();
	},

	watch: {
		requestUrl: function() {
			this.getItems();
		}
	},

	computed: {
		requestUrl() {
			if(!this.listItems.length) {
				let query = this.query;

				if(this.endpoint.indexOf('?') < 0 && query !== '') {
					query = '?' + query;
				}

				return this.endpoint + query;
			}
			
			return '';
			
		},

		showMoreUrl() {
			let str = '';
			let nextPage = this.pagination.current_page + 1;

			if(this.requestUrl.indexOf('?') < 0) {
				str = '?';
			} else {
				str = '&';
			}

			return this.requestUrl + str + 'page=' + nextPage;
		},
		
		columnClass() {
			let col = this.cols;
			
			return 'w-full sm:w-1/2 md:w-1/' + col;
		}
	},

	methods: {
		getItems() {
			if(this.listItems.length) {
				this.loading = false;
				this.items = this.listItems;
				
			} else {
				this.loading = true;
				this.$emit('loading', this.requestUrl);
	
				this.sendRequest(this.requestUrl, 'get', this.updateItems);
			}
		},

		itemType(item = null) {
			if(this.listType) {
				return this.listType;
			} else {
				return item.model_code + '-card';
			}
		},

		updateItems(data, message) {
			this.loading = false;

			if(data.current_page) {
				this.items = data.data;
				this.pagination = data;
			} else {
				this.items = data;
			}
			
			this.$emit('loaded', this.items, this.pagination);
		},

		appendItems(data, message) {
			this.loadingMore = false;
			if(data.current_page) {
				this.items = this.items.concat(data.data);
				this.pagination = data;
			} else {
				this.items = this.items.concat(data);
			}

			this.$emit('loaded-more', this.items, this.pagination);
		},

		loadMore(page) {
			clearTimeout(this.debounce);

			this.loadingMore = true;
			this.$emit('loading-more', this.showMoreUrl);

			this.debounce = setTimeout(function(){
				this.sendRequest(this.showMoreUrl, 'get', this.appendItems);
			}.bind(this), 500);
		}
	}
}
